import { getTranslatedText } from "../../../../utils/getTranslatedText";
import Modal from "../../../modal/Modal";
import Button from "../ButtonComponent";

import CheckSvgComponent from "../CheckSvgComponent";
import { useGetTranslatedText } from "../queries";
// import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

const EnrollmentSuccessfulComponent = (props) => {
  const { assessmentType , enrollmentSuccessfull , handleClick , isPending , preAssessment } = props;

  const languageId = localStorage.getItem("l_id") || 1;

  const {data:translatedTextResponse} = useGetTranslatedText(languageId)
  
  const {data:translatedText = []} = translatedTextResponse || {};

  return (
    <>
      <Modal visible={enrollmentSuccessfull}>
        <div className={styles["assessment-wrapper"]}>
          <CheckSvgComponent />
          <div className={styles.title}>{getTranslatedText(translatedText,"key_success_enroll","Enrollment Successful")}</div>
          <div className={styles.description}>
            {getTranslatedText(translatedText,"enroll_course_message_success",'You have successfully enrolled in this course.')}
          </div>
{  preAssessment=== 1     ? '' :  <div className={styles.note}>
            To start the course, please complete the
            <span className={styles["highlight-note"]}>
              {assessmentType || "Pre-Assessment first"}.
            </span>
            This will help us understand your learning level.
          </div>}
          <div className={styles["button-wrapper"]}>
          <Button
          label={preAssessment===1 ? getTranslatedText(translatedText,"key_start_learning",'Start Learning') :getTranslatedText(translatedText ,"key_start_pre_assessment" ,"Start Pre-Course Assessment")}
          // disabled={!isVideoCompleted}
          disabled={isPending}
          className={styles.button}
          onClick={handleClick}
         />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EnrollmentSuccessfulComponent;
